module.exports = __webpack_public_path__ + "static/media/spartan-king.9ab227d7.gif";